// Toast mutations
const ADD_MODAL = 'modals/ADD_MODAL';
const REMOVE_MODAL_BY_NAME = 'modals/REMOVE_MODAL_BY_NAME';
const REMOVE_LAST_MODAL = 'modals/REMOVE_LAST_MODAL';
const REMOVE_ALL_MODALS = 'modals/REMOVE_ALL_MODALS';

let modalID = 1;

// initial state
const state = {
  items: []
};

// mutations
const mutations = {
  [ADD_MODAL] (state, modal) {
    state.items.push(modal);
  },

  [REMOVE_MODAL_BY_NAME] (state, name) {
    state.items = state.items.filter(m => m.name !== name);
  },

  [REMOVE_LAST_MODAL] (state) {
    state.items.pop();
  },

  [REMOVE_ALL_MODALS] (state) {
    state.items = [];
  }
};

const actions = {
  addModal: ({ commit, dispatch }, component) => {
    const id = modalID++;
    commit(ADD_MODAL, { id, name: component.name, component });
  },

  removeModal: ({ commit }, name = '') => {
    if (name.length) {
      commit(REMOVE_MODAL_BY_NAME, name);
    } else {
      commit(REMOVE_LAST_MODAL);
    }
  }
};

const getters = {
  modals (state) {
    return state.items;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/modals/module.js